import { Component, OnDestroy } from '@angular/core'
import { ExtraService } from '../../services/extra/extra.service'
import { NavController, ActionSheetController, Platform, LoadingController } from '@ionic/angular'
import { AlertService } from '../../services/alert/alert.service'
import { UserService } from '../../services/user/user.service'
import { IEvent, EventService } from '../../services/event/event.service'
import { IUser } from 'src/app/services/user/user.service'

@Component({
  selector: 'app-event',
  templateUrl: './event.page.html',
  styleUrls: ['./event.page.scss'],
})
export class EventPage implements OnDestroy {

  user: IUser = null
  userSubscription: any

  eventList: IEvent[] = []
  eventListSubscription: any

  search = ''
  filter: TFilter = null

  isAndroid = false

  constructor(
    private userService: UserService,
    private extraService: ExtraService,
    private eventService: EventService,
    private alert: AlertService,
    private navCtrl: NavController,
    private actionSheetCtrl: ActionSheetController,
    private loadingController: LoadingController,
    private platform: Platform
  ) {
    this.userSubscription = this.userService.currentUser.subscribe(value => this.user = value)
    this.eventListSubscription = this.eventService.eventList.subscribe(value => {
      // console.log(value)
      this.eventList = value.filter(v => {
        if (
          !this._toBoolean(v.cancelled) || // (v.ownerName === this.user.name) ||
          (this._toBoolean(v.cancelled) && v.hasTicketsFrom && this._toBoolean(v.paid) && v.hasTicketsFrom !== this.user.name) ||
          (this._toBoolean(v.cancelled) && v.buysTicketsFor && v.users.findIndex(u => u.hasTicket === this.user.id && u.userId !== this.user.id && this._toBoolean(u.paid)) !== -1)
        )
          return v

        return null
      })
    })

    this.platform.ready().then(() => {
      if (this.platform.is('android'))
        this.isAndroid = true
    })
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe()
    this.eventListSubscription.unsubscribe()
  }

  update() {
    this.loadingController.create({
      message: 'Wird geladen',
      showBackdrop: false
    })
      .then(loading => loading.present()
        .then(() => this.extraService.updateAllLists(this.user.token, this.user.id))
        .catch((err) => this.alert.errorHandler(err, 'Fehler beim Aktualizieren von Daten!'))
        .then(() => loading.dismiss())
      )
  }

  gotoEventDetails(event: IEvent) {
    this.navCtrl.navigateForward(`/event-details/${event.id}`)
  }

  gotoEventNew() {
    this.navCtrl.navigateForward(`/event-new`)
  }

  trackByFn(index, item) {
    return item.id
  }

  filterToString(value: TFilter): string {
    switch (value) {
      case 'my':
        return 'Meine Veranstaltungen'
      case 'new':
        return 'Neue Veranstaltungen'
      default:
        return 'Alle Veranstaltungen'
    }
  }

  async showFiltersActionSheet() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Filter',
      buttons: [
        {
          text: 'Neue Veranstaltungen',
          icon: this.filter === 'new' ? 'checkmark-circle-outline' : 'radio-button-off',
          cssClass: this.filter === 'new' ? 'blue' : '',
          handler: () => {
            this.filter = 'new'
          }
        }, {
          text: 'Meine Veranstaltungen',
          icon: this.filter === 'my' ? 'checkmark-circle-outline' : 'radio-button-off',
          cssClass: this.filter === 'my' ? 'blue' : '',
          handler: () => {
            this.filter = 'my'
          }
        }, {
          text: 'Alle Veranstaltungen',
          icon: !this.filter ? 'checkmark-circle-outline' : 'radio-button-off',
          cssClass: !this.filter ? 'blue' : '',
          handler: () => {
            this.filter = null
          }
        }, {
          text: 'Abbrechen',
          icon: 'close',
          role: 'cancel'
        }
      ]
    })
    await actionSheet.present()
  }

  isVisible(event: IEvent) {
    const searchIn = event.name.toLowerCase().search(this.search.toLowerCase()) !== -1 ||
      (event.place && event.place.toLowerCase().search(this.search.toLowerCase()) !== -1)

    let filterIn
    if (!this.filter)
      filterIn = true
    else if (this.filter === 'new')
      filterIn = typeof event.takesPart === 'undefined' || !(event.takesPart !== null || event.ownerName === this.user.name)
    else if (this.filter === 'my')
      filterIn = typeof event.takesPart !== 'undefined' && (event.takesPart !== null || event.ownerName === this.user.name)

    return searchIn && filterIn
  }

  gotoProfile() {
    this.navCtrl.navigateForward('/profile')
  }

  _toBoolean(val) {
    if (typeof val !== 'undefined' && (val === true || val === 'true' || val === '1' || val === 1))
      return true
    else
      return false
  }
}

type TFilter = 'my' | 'new'
